import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import FormFieldTimestamp from "components/FormFields/Timestamp";
import FormFieldViewText from "components/FormFields/ViewText";
import { Revision } from "types/generated";

type CommitDetailsDrawerProps = {
  revision: Revision;
};

const CommitDetailsDrawer = createDrawer(({ revision }: CommitDetailsDrawerProps) => {
  const author = revision.authorEmail || revision.authorName;

  return (
    <DrawerSimple>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Commit details" />
        <DrawerCloseIcon />
      </DrawerHeader>

      <DrawerBody>
        <FormFieldViewText label="SHA" value={revision.sha} withCopy />
        <FormFieldViewText label="Message" value={revision.message} />
        {revision.description && (
          <FormFieldViewText label="Description" value={revision.description} />
        )}
        {author && <FormFieldViewText label="Author" value={author} />}
        <FormFieldTimestamp label="Committed at" timestamp={revision.createdAt} />
        <FormFieldViewText label="Files changed" value={String(revision.files.length)} />
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showCommitDetailsDrawer = createDrawerTrigger(CommitDetailsDrawer);
